<script setup>
import Join from '@sections/home/join.vue'
import Hero from '@sections/news/hero.vue'
import NewsList from '@sections/news/news-list.vue'
import { useNewsStore } from '@stores/news.js'

import Loading from '@components/global/loading.vue'

const news = useNewsStore()
</script>

<template>
	<Loading v-if="!news.articles.length" />
	<template v-else>
		<Hero />
		<NewsList />
		<Join class="lg:mt-[13%]" />
	</template>
</template>
